import { getLocalStorage } from 'src/utils/browserStorageHandler';
import { ADD_AND_REMOVE_DEVICE } from 'src/utils/constants/ApiConstants';
import {
  GUEST_TOKEN,
  USER_TOKEN
} from 'src/utils/constants/localStorageConstants';
import { HTTP_HEADER_KEYS } from '../../utils/constants/HttpMethodsConstants';

export const addAndRemoveDevice = async () => {
  const params = {
    name: 'WebBrowser',
    identifier: getLocalStorage(GUEST_TOKEN) || 'WebBrowser'
  };
  // Object.keys(params).forEach(key => addDeviceUrl.searchParams.append(key, params[ key ]))
  const headers = {
    Accept: 'application/json',
    Authorization: `bearer ${getLocalStorage(USER_TOKEN)}`,
    'Content-Type': 'application/json'
  };
  // const headers = [ HTTP_HEADER_KEYS.ACCEPT, HTTP_HEADER_KEYS.AUTHORIZATION, HTTP_HEADER_KEYS.CONTENT_TYPE]
  // TODO :: Replace with http service
  await fetch(ADD_AND_REMOVE_DEVICE, {
    method: 'POST',
    body: JSON.stringify(params),
    headers
  })
    .then((response) => {
      if (response.status === 400 || response.status === 401) {
        // console.log('something error');
      }
      return response.json();
    })
    .then((data) => {
      if (data.code && data.code.toString() === '3602') {
        removeDevice();
      }
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
};

export const removeDevice = async () => {
  const params = {
    name: 'WebBrowser',
    identifier: getLocalStorage(GUEST_TOKEN) || 'WebBrowser'
  };
  const headers = {
    Accept: 'application/json',
    Authorization: `bearer ${getLocalStorage(USER_TOKEN)}`,
    'Content-Type': 'application/json'
  };
  // const headers = [ HTTP_HEADER_KEYS.ACCEPT, HTTP_HEADER_KEYS.AUTHORIZATION, HTTP_HEADER_KEYS.CONTENT_TYPE]
  // TODO :: Update with HTTP service
  await fetch(ADD_AND_REMOVE_DEVICE, {
    method: 'delete',
    body: JSON.stringify(params),
    headers
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
};
